// extracted by mini-css-extract-plugin
export var avatarContainer = "_46-1";
export var largeAvatarContainer = "_46-2";
export var smallAvatarContainer = "_46-0";